import { render, staticRenderFns } from "./NewsPageBusinessline.vue?vue&type=template&id=6a5b29ef&scoped=true&"
import script from "./NewsPageBusinessline.vue?vue&type=script&lang=js&"
export * from "./NewsPageBusinessline.vue?vue&type=script&lang=js&"
import style0 from "./NewsPageBusinessline.vue?vue&type=style&index=0&id=6a5b29ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b29ef",
  null
  
)

export default component.exports